/**
 * Helpers for the Domain Name service type (Synergy Wholesale registry integration).
 *
 * The backend service type code lives in env (DOMAIN_NAME_SERVICE_TYPE_CODE) and
 * defaults to "domain_name". The constant here is matched defensively against
 * common variants (case + dash/underscore) so renaming the type in Settings does
 * not silently break the panel.
 */

/** Canonical lowercase/underscored code for the Domain Name service type. */
export const DOMAIN_NAME_SERVICE_TYPE_CODE = 'domain_name';

/** True when this service is the Synergy Wholesale Domain Name type. */
export function isDomainNameServiceType(
  serviceTypeCode: string | null | undefined,
  serviceTypeName?: string | null,
): boolean {
  const c = (serviceTypeCode || '').trim().toLowerCase().replace(/-/g, '_');
  if (c === DOMAIN_NAME_SERVICE_TYPE_CODE) return true;
  if (c === 'domain' || c === 'domainname') return true;
  const n = (serviceTypeName || '').trim().toLowerCase();
  return n === 'domain name' || n === 'domain';
}

/** Lightweight FQDN sanity check used by the service form. */
export function isLikelyFqdn(value: string): boolean {
  const v = (value || '').trim().toLowerCase();
  if (!v || v.length > 253) return false;
  if (v.includes(' ') || v.includes('/')) return false;
  // Two or more labels, each 1-63 chars, alphanumerics + hyphen, not starting/ending with hyphen.
  return /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/.test(v);
}
